<template>
    <!-- 设备信息 -->
  <div class="body">
    <div class="deviceTitle">
      <div>
        <img :src="getImageSrc(battery)" alt="" style="width: 158px" />
      </div>
      <div>
        <p>
          {{ $t("设备ID") }}: {{ did }}
          <Icon
            v-if="did"
            type="md-copy"
            class="icon"
            @click="copyToClipboard(did)"
          /><Icon
            v-if="did"
            type="md-apps"
            class="icon"
            @click="getQrCode(did)"
          />
        </p>
        <p>
          {{ $t("设备SN") }}: {{ SN }}
          <Icon
            v-if="SN"
            type="md-copy"
            class="icon"
            @click="copyToClipboard(SN)"
          />
        </p>
        <p>{{ $t("更新时间") }}:{{ assign_time }}</p>
      </div>
      <div>
        <img :src="qr_url" alt="" />
      </div>
    </div>
    <div class="content">
      <div class="leftContent">
        <p><span>设备名称</span> : <span>1</span></p>
        <p><span>逆变器型号</span> : <span>2</span></p>
        <p><span>额定功率</span> : <span>3</span></p>
        <p><span>厂家名称</span> : <span>4</span></p>
        <p><span>WIFI设备名称</span> : <span></span></p>
        <p><span>设备实时时间</span> : <span></span></p>
        <p><span>设备注册地址</span> : <span></span></p>
      </div>
      <div class="rightContent">
        <p><span>协议版本号</span> : <span></span></p>
        <p><span>主控板硬件版本号</span> : <span></span></p>
        <p><span>主控板开发软件版本号</span> : <span></span></p>
        <p><span>主控板发布软件版本号</span> : <span></span></p>
        <p><span>显示屏硬件版本号</span> : <span></span></p>
        <p><span>显示屏开发软件版本号</span> : <span></span></p>
        <p><span>显示屏发布软件版本号</span> : <span></span></p>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'deviceinfo',
  data () {
    return {
      battery: 30,
      did: '111',
      SN: '22222'
    }
  },
  components: {},
  methods: {
    getImageSrc (value) {
      if (value >= 0 && value <= 10) {
        return require('@/assets/images/lowD.png')
      } else if (value >= 11 && value <= 30) {
        return require('@/assets/images/centerD.png')
      } else if (value >= 31 && value <= 60) {
        return require('@/assets/images/heightD.png')
      } else if (value >= 61 && value <= 100) {
        return require('@/assets/images/fullD.png')
      }
      return '' // 默认值
    },
    copyToClipboard (text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          // alert('已复制: ' + text);
          this.$Message.success(this.$t('复制成功'))
        })
        .catch((err) => {
          console.error('复制失败:', err)
        })
    }
  }
}
</script>

<style scoped>
.body {
  padding: 16px;
  margin: 16px;
  background: white;
}
.deviceTitle {
  display: flex;
  align-items: center;
}
.deviceTitle div {
  width: 33%;
}
.deviceTitle div p {
  margin-top: 20px;
}
.deviceTitle div p .icon {
  font-size: 36px;
}
.icon {
  cursor: pointer; /* 鼠标悬浮时显示小手 */
  margin-left: 5px;
  transition: transform 0.2s; /* 添加过渡效果 */
}
.content {
  display: flex;
  align-items: center;
}
.content div {
  width: 33%;
}
.content div p{
  margin-top:5px;
}
</style>
